import React from "react";
import { useState,useEffect,useRef } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import Editor from 'react-simple-wysiwyg';
import { Helmet } from "react-helmet";
import './classes/EditDocTalk.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';
import ViewDocTalk from "./ViewDocTalk";
import Select from 'react-dropdown-select';

const EditDocTalk =()=>{
 
 
        const initialFormData = { 
            title:'',            
            summary: '',
            body: '',
            doc_talk_mentor_image_upload: '',
            // field_delete_photo:0,
            // field_doc_talk_mentor_image:'',
            videoLink: '',
            audioLink: '',
            field_doc_talk_chat_time:'',
            field_zoom_chat_link:'',
            field_passcode:'',
            field_form_frontend_title:'',
            relate_sports:'',
            relate_sortflag:'',
            mentors: [{ mentor_name: "", mentor_role: "", mentor_sortby: "0", field_doc_talk_mentor_image: "", field_delete_photo:0 }],
            deleted_mentors: [],
           
        };
        const [formData,setFormData] =useState(initialFormData);
        const [isLoading, setIsLoading] = useState(true);
        const [toggle, setToggle] = useState(2);
        const [errors, setErrors] = useState({});
        const [selectedFiles, setSelectedFiles] = useState([]);       
        const [errorMessage, setErrorMessage] = useState('');
        const [showSummary, setShowSummary] = useState(false);
        const [useRichEditor, setUseRichEditor] = useState(true);
        const [useFrontendTitleEditor, setUseFrontendTitleEditor] = useState(true);
        const [savedData, setSavedData] = useState(initialFormData);
        const [PreviewFields, setPreviewFields] = useState(false);  
        const [viewChanges, setViewChanges] = useState(false);    
        const [previewData, setPreviewData] = useState(null);
        const [originalData, setOriginalData] = useState(null);
        const [formDataSnapshot, setFormDataSnapshot] = useState(null);
        const [selectedImage, setSelectedImage] = useState({});
        const [savedImageInfo, setSavedImageInfo] = useState({ size: null});
        const [imageUploadError, setImageUploadError] = useState('');
        const [imageRemoved, setImageRemoved] = useState(false);
        const [tempImage, setTempImage] = useState(null);
        const [tempImageFile, setTempImageFile] = useState({});
        const fileInputRef = useRef(null);

        const[sortflagList, setSortflagList] = useState([]);

            const location  = useLocation();
            const drupal_uid = localStorage.getItem('drupal_uid');
            const[drupalUID,setDrupalUID] = useState({});
            const[userSlug,setUserSlug] = useState({});
            const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
            var loggedin_domain = drupal_domain_url;
            if(localStorage.getItem('loggedin_domain')) {
            loggedin_domain = localStorage.getItem('loggedin_domain');
            } 
            var {nid} = useParams();
            var {username} = useParams();
            if(location.state) {
            nid = location.state;
            }
            const {tab} = useParams();
            const loggedin_uid = localStorage.getItem('uid');
            const navigate = useNavigate();
            const app_url = configData.APP_URL;
            const domain_url = configData.DOMAIN_URL;

              function updateToggle(id){
                   setToggle(id);
               
                   if(id == 1) { 
                   
                     navigate("/doc-talk-mentors/"+nid+"/view");
                   }
                   if(id == 2) { 
                     navigate("/doc-talk-mentors/"+nid+"/edit");
                   }  
                 }
             
                 useEffect(() => {
                   if(tab == "view") {
                     setToggle(1);
             
                   }
                   if(tab == "edit") {
                     setToggle(2);
                   }
                     
                 } ,[tab]);
          
                 useEffect(() => {
                    
                     Promise.all([
                           retrivedoctalkdetails(),
                           retrieveSortFlags(),
                          ]).then(() => {
                     
                            setIsLoading(false);
                           
                          })
                       
                    
                    
                     
                   },[]);
      async function retrivedoctalkdetails() {
    try {
        const response = await fetch(
        app_url+'doctalk/getmanagedoctalkdetails?nid='+nid,
        {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
        }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg === "Success") {
          const result = responsedata.data.result;
		  
          const updatedForm = {

            title:result.title, 
            nid:result.nid,          
            summary: '',
            body: result.body,
            // doc_talk_mentor_image_upload: result.field_doc_talk_mentor_image,
            // field_delete_photo:0,
            // field_doc_talk_mentor_image:'',
            videoLink: result.videoLink,
            audioLink: result.audioLink,
            field_doc_talk_chat_time:result.field_doc_talk_chat_time,
            field_zoom_chat_link:result.field_zoom_chat_link,
            field_passcode:result.field_passcode,
            field_form_frontend_title:result.field_form_frontend_title,
            relate_sports:result.relate_sports,
            // relate_sortflag:result.relate_sortflag,
            relate_sortflag: Number(result.relate_sortflag),
            mentors: result.mentors,
    };
              setSavedData(updatedForm);
              setFormData(updatedForm);     
        }
    }catch (err) {
       
      }

  
  }


  async function  retrieveSortFlags() {
  
    const response = await fetch(
      app_url+'sortflag/getnewsortflaglist',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setSortflagList(responsedata.data.result);
    }
  }

             const cleanHtmlOutput = (html) => {
        if (!html) return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : html.trim();
    };
    const handleEditorChange = (e) => {
        setFormData(prev => ({
            ...prev,
            body: e.target.value
        }));
    };
const handlePreviewClick = () => {
  setViewChanges(false);
  const {
     title,
     summary,
     body,
     doc_talk_mentor_image_upload,
     videoLink,
     audioLink,
     field_doc_talk_chat_time, 
     field_zoom_chat_link,
     field_passcode,
     field_form_frontend_title     
  } = formData;


  const newErrors = {};
  if (!title.trim()) {
    newErrors.title = "Title is required.";
  }
 

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    setPreviewFields(false);
    return;
  }
  const bodyHtml = body || '';
  const hasSummary = summary && summary.trim() !== '';
  let trimmedHtml = '';

  if (hasSummary) {
  trimmedHtml = summary;
} else if (bodyHtml.includes('<!--break-->')) {
  trimmedHtml = bodyHtml.split('<!--break-->')[0];
} else {
  const tmp = document.createElement('div');
  tmp.innerHTML = bodyHtml;
  const plainText = (tmp.textContent || tmp.innerText || "").trim();

  // Get first sentence or fallback
  let snippet = plainText.split('. ')[0];
  if (snippet.length < 20) {
    snippet = plainText.substring(0, 200);
  }

  trimmedHtml = snippet ? `<p>${snippet}</p>` : '';

}

 

  setPreviewData({
    title,
    summary: hasSummary ? summary : '',
    body: bodyHtml,
    doc_talk_mentor_image_upload,
    videoLink,
    audioLink,
    field_doc_talk_chat_time, 
    field_zoom_chat_link,
    field_passcode,
    field_form_frontend_title
    
  });
  window.scrollTo(0, 0);
  setErrors({});
  setPreviewFields(true);  
};
const handleViewChangesClick = () => {
  setPreviewFields(false);
  const newErrors = {};

  if (!formData.title.trim()) {
    newErrors.title = 'Title field is required.';
  }
 
  setErrors(newErrors);

  //  Don't return immediately, just stop enabling view changes
  if (Object.keys(newErrors).length > 0) {
    setViewChanges(false);
  } else {
    setViewChanges(true);
    setOriginalData(savedData);
    setFormDataSnapshot(formData);
    window.scrollTo(0, 0);
  }
};
    const onEditorChange = (field, e, isRich = true) => {
        let newHtml = e.target.value;


        // Normalize editor output
        const isEmptyHtml = newHtml.trim() === '' || newHtml === '<br>' || newHtml === '<p><br></p>';

        if (isEmptyHtml) {
            newHtml = '';
        } else if (isRich && !newHtml.trim().startsWith('<')) {
        // Wrap plain text in <p> if it's not already HTML
            newHtml = `<p>${newHtml}</p>`;
        }

        setFormData(prev => ({ ...prev, [field]: newHtml }));
    };
 const formatFileSize = (sizeInBytes) => {
  if (sizeInBytes < 1024) {
    return `${sizeInBytes} bytes`;
  } else if (sizeInBytes < 1024 * 1024) {
    return `${(sizeInBytes / 1024).toFixed(2)} KB`;
  } else {
    return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
  }
};
//  const handleTempImageChange = (e) => {
//   const file = e.target.files[0];
//   if (!file) return;

//   const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
//   const maxSize = 128 * 1024 * 1024; // 128 MB
//     const minWidth = 480;
//   const minHeight = 480;

//   const errors = [];

//   if (!validTypes.includes(file.type)) {
//     errors.push('Allowed file types: png, gif, jpg, jpeg.');
//   }

//   if (file.size > maxSize) {
//     errors.push('File must be less than 128 MB.');
//   }
 
//    const img = new Image();


// const objectUrl = URL.createObjectURL(file);
//     const { width, height } = img;


//     if (width < minWidth || height < minHeight) {
//       errors.push('Image must be at least 480x480 pixels.');
//       URL.revokeObjectURL(objectUrl);
//     }
//   if (errors.length > 0) {
//     alert(errors.join('\n'));
//     e.target.value = '';
//     setSelectedImage(null);
//     return;
//   }

  
 


//   // Store both preview URL and file name/size
//   setSelectedImage({
//     file,          // actual File object
//     preview: objectUrl // blob URL for preview
//   });

//   // Update formData for backend submission
//   setFormData(prev => ({
//     ...prev,
//     field_doc_talk_mentor_image: file // keep actual file object for submission
//   }));

//   setImageRemoved(false);
// };
const addSizeAttribute = () => {
  setFormData((prev) => ({
    ...prev,
    mentors: [
      ...(Array.isArray(prev.mentors) ? prev.mentors : []),
      {
        mentor_name: "",
        mentor_role: "",
        mentor_sortby: "0",
        field_doc_talk_mentor_image: "",
        field_delete_photo:0,
      }
    ],
  }));
};

    const handleSizeChange = (index, field, value) => {
        setFormData((prev) => {
            const updatedSizes = [...prev.mentors];
            updatedSizes[index] = {
                ...updatedSizes[index],
                [field]: value,
            };

            const updatedSize = updatedSizes[index];

            const shouldDelete =
                updatedSize.id &&                     // must have id
                (updatedSize.mentor_name?.trim() === "" &&   // name empty
                updatedSize.mentor_role?.trim?.() === "" &&   // name empty
                updatedSize.field_doc_talk_mentor_image === ""); // price empty

            return {
                ...prev,
                mentors: updatedSizes,
                deleted_mentors: shouldDelete
                    ? [...new Set([...prev.deleted_mentors, updatedSize.id])] // avoid duplicates
                    : prev.deleted_mentors,
            };
        });
    };

    const removeSizeAttribute = (index) => {
        setFormData((prev) => {
            const sizeToRemove = prev.mentors[index];

            return {
                ...prev,
                deleted_mentors: sizeToRemove?.id
                ? [...(prev.deleted_mentors ?? []), sizeToRemove.id]
                : (prev.deleted_mentors ?? []),

                mentors: prev.mentors.filter((_, i) => i !== index),
            };
        });
    };

const handleTempImageChange = (e, index) => {
  const file = e.target.files[0];
  if (!file) return;

  setTempImageFile({file, index}); // Save temporarily
};
const handleUploadClick = (e) => {
  if (!tempImageFile || !tempImageFile.file) return;

  const { file, index } = tempImageFile;

  const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
  const maxSize = 128 * 1024 * 1024; // 128 MB
  const minWidth = 400;
  const minHeight = 400;

  const errors = [];

  if (!validTypes.includes(file.type)) {
    errors.push('Allowed file types: png, gif, jpg, jpeg.');
  }

  if (file.size > maxSize) {
    errors.push('File must be less than 128 MB.');
  }

  const objectUrl = URL.createObjectURL(file);
  const img = new Image();

  img.onload = () => {
    if (img.width < minWidth || img.height < minHeight) {
      errors.push('Image must be at least 400x400 pixels.');
    }

    if (errors.length > 0) {
     // alert(errors.join('\n'));
          const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded.<br>${errors.join('<br>')}`;
              setImageUploadError(errorHTML);
               e.target.value = ''; // Reset input
      setTempImageFile(null);
      URL.revokeObjectURL(objectUrl);
      return;
    }
  setImageUploadError('');
    // Passed validation → update preview + formData
    setSelectedImage((prev) => ({
      ...prev,
      [index]: {
        file,
        preview: objectUrl,
      },
    }));

    setFormData((prev) => {
      const updated = [...prev.mentors];

      updated[index] = {
        ...updated[index],
        field_doc_talk_mentor_image: file,
      };

      return {
        ...prev,
        mentors: updated,
      };
    });

    setImageRemoved(false);
    setTempImageFile(null); // clear temp
  };

  img.onerror = () => {
    //alert('Could not load image.');
     setImageUploadError(`The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>.`);
    setTempImageFile(null);
    URL.revokeObjectURL(objectUrl);
  };

  img.src = objectUrl;
};

const removeImage = (index) => {
  setSelectedImage((prev) => {
    const updated = { ...prev };
    if (updated[index]?.preview) {
      URL.revokeObjectURL(updated[index].preview);
    }
    delete updated[index];
    return updated;
  });

  setTempImageFile(null);
  setImageUploadError('');

  setFormData((prev) => {
    const updated = [...prev.mentors];

    updated[index] = {
      ...updated[index],
      field_doc_talk_mentor_image: "",
      field_delete_photo: 1,
    };

    return {
      ...prev,
      mentors: updated,
    };
  });
};

useEffect(() => {
  if (formData.doc_talk_mentor_image_upload) {
    fetch(formData.doc_talk_mentor_image_upload)
      .then(res => res.blob())
      .then(blob => {
        setSavedImageInfo({ size: blob.size });
      })
      .catch(() => {
        setSavedImageInfo({ size: null });
      });
  }
}, [formData.doc_talk_mentor_image_upload]);

const getImageSrc = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value; // already a URL from backend
  if (value.preview) return value.preview; // wrapper object { file, preview, name }
  if (value.file && value.file instanceof File) return URL.createObjectURL(value.file); // has file
  if (value instanceof File) return URL.createObjectURL(value); // plain File object
  return "";
};
// const getFileName = (value) => {
//   if (!value) return "";
//   if (typeof value === "string") {
//     return value.split("/").pop(); // extract filename from URL
//   }
//   if (value.name) return value.name; // File object or wrapper with .name
//   if (value.file && value.file.name) return value.file.name; // wrapper {file, preview, name}
//   return "";
// };
//   const imageValue = (index) =>
//     selectedImage[index]?.file || formData.mentors[index]?.field_doc_talk_mentor_image;
//   const fileName =
//     imageValue && typeof imageValue === "object" && imageValue.name
//       ? imageValue.name
//       : typeof imageValue === "string"
//       ? imageValue.split("/").pop()
//       : "";
    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };
 useEffect(() => {
  const now = new Date();
  
  const pad = (num) => String(num).padStart(2, '0');
  
  const year = now.getFullYear();
  const month = pad(now.getMonth() + 1); // Months are 0-based
  const day = pad(now.getDate());
  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());

  const formatted = `${month}/${day}/${year} ${hours}:${minutes}`;

  setFormData(prev => ({
    ...prev,
    field_doc_talk_chat_time: formatted
  }));
}, []);
const getFullFileUrl = (path) => {
  console.log("getFullFileUrl received:", path);

  // Handle File object
  if (path instanceof File) {
    return URL.createObjectURL(path); // Creates a temporary local URL for preview
  }

  // If it's a string (URL or path)
  if (!path || typeof path !== "string") return "";

  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  const baseUrl = window.location.origin;
  return `${baseUrl}${path}`;
};
const imageUrl = getFullFileUrl(formData.doc_talk_mentor_image_upload);

  const getPageTitle = () => {
      if (toggle === 1) {
          return savedData.title
          ? `${savedData.title}`
          : 'View Doc Talk Speakers';
      } else {
          return savedData.title
          ? `Edit Doc Talk Speakers ${savedData.title}`
          : 'Edit Doc Talk Speakers';
      }
  };
        const validateForm = () => {
            const newErrors = {};
            if (!formData.title.trim()) {
                newErrors.title = "Title is required.";
            }
            return newErrors;
        };
         const inputStyle = {
  title: {
    border: errors.title ? '2px solid red' : '1px solid #777'
  },
 
 };
    const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData(prev => ({ ...prev, [name]: value }));
        };
const handleSubmit = async (e) => {
  e.preventDefault();

  const validationErrors = validateForm();
  setErrors(validationErrors);
  const postData = new FormData();
  
      // if (selectedImage && selectedImage.file) {
      //   postData.append('doc_talk_mentor_image_upload', selectedImage.file);
      // }
  formData.mentors.forEach((mentor, index) => {
    const image = selectedImage[index];

    if (image && image.file) {
      postData.append(
        `mentors[${index}][field_doc_talk_mentor_image]`,
        image.file
      );
    }
  });

  const finalBody = cleanHtmlOutput(formData.body);
    //  Auto-generate summary if it's blank
  const finalSummary = (!formData.summary || formData.summary.trim() === "")
    ? finalBody.slice(0, 200) 
    : formData.summary;

  const updatedFormData = {
    ...formData,
    body: finalBody,
    summary: finalSummary,
  };
postData.append('formData', JSON.stringify(updatedFormData));
  if (Object.keys(validationErrors).length === 0) {
    setSavedData(updatedFormData);
    const response = await fetch(app_url+'doctalk/updatedoctalk', {
      method: 'POST',
      body: postData,
      });
      const data = await response.json();
      if(data.data.msg === "Success") {
        
          setErrors({});
           navigate("/manage-doc-talk-mentors", { state: { message: data.data.result } });
          
          // Optional: reset form
          //setFormData(initialForm);
      }
  }
};
const handleDelete = async () => {
   if (window.confirm("Are you sure you want to delete?")) {
    const response = await fetch(
        app_url+'doctalk/deletedoctalk?nid='+nid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
       const data = await response.json();
      if(data.data.msg == "Success") { 
         
          navigate("/manage-doc-talk-mentors", { state: { message: data.data.result } });
           
        }
  }

};

    return(
         <>
            {isLoading ? (
                <Loading />
            ) : (
        <div id="main">
             <Helmet>
                <title>
                    {getPageTitle()}
                </title>
            </Helmet>
            <div className="left"></div>
            <div className="center left-center">

                <>
                      <ul className="tabs primarya">
                        <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>View</a></li>
                     
                        <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Edit</a></li>
                        {/* )} */}
                      </ul></>
                           <div  className= {toggle === 1? "show-content" : "content"}>
                              <ViewDocTalk savedData={savedData} />
                          </div>
                          <div  className= {toggle === 2? "show-content" : "content"}>
             {viewChanges && (
<div className='diff-table-wrapper'>
  <table className="diff-table">
  <colgroup>
    <col className="diff-marker" />
    <col className="diff-content" />
    <col className="diff-marker" />
    <col className="diff-content" />
  </colgroup>
  <thead>
    <tr>
      <th colSpan="2">Original</th>
      <th colSpan="2">Changes</th>
    </tr>
  </thead>
  <tbody>
    {!formDataSnapshot || !originalData ? (
      <tr className="no-changes">
        <td className="diff-section-title" colSpan="4">No visible changes</td>
      </tr>
    ) : (
      (() => {
        const diffs = [];

    
        const compareField = (label, oldValue = '', newValue = '') => {
  if (oldValue === newValue) return null;

  const oldLines = (oldValue ?? '').split('\n');
  const newLines = (newValue ?? '').split('\n');
  const maxLines = Math.max(oldLines.length, newLines.length);

  const rows = [
    <tr className="diff-section-title" key={`${label}-title`}>
      <td colSpan="4">Changes to <em>{label}</em></td>
    </tr>
  ];

  for (let i = 0; i < maxLines; i++) {
    const oldLine = (oldLines[i] || '').trim();
    const newLine = (newLines[i] || '').trim();

    if (oldLine !== newLine) {
      const oldWords = oldLine.split(/\s+/);
      const newWords = newLine.split(/\s+/);
      const maxWords = Math.max(oldWords.length, newWords.length);

      const renderWords = (wordsA, wordsB, isOld) =>
        wordsA.map((word, idx) => {
          const matchingWord = wordsB[idx] || '';
          const changed = word !== matchingWord;

          return (
            <span
              key={`${label}-${isOld ? 'old' : 'new'}-${i}-${idx}`}
              style={changed ? {
                color: isOld ? 'red' : 'red',
                borderRadius: '4px',
                padding: '0 3px',
                fontWeight:'bold'
              } : {}}
            >
              {word}
              {' '}
            </span>
          );
        });

      rows.push(
        <tr key={`${label}-${i}`}>
          <td style={{width:"2px"}}><span>-</span></td>
          <td className="diff-removed">{renderWords(oldWords, newWords, true)}</td>
          <td style={{width:"2px"}}><span>+</span></td>
          <td className="diff-added">{renderWords(newWords, oldWords, false)}</td>
        </tr>
      );
    }
  }

  return rows;
};


         diffs.push(...(compareField('Title', originalData.title, formDataSnapshot.title) || []));   
         diffs.push(...(compareField('Summary', originalData.summary, formDataSnapshot.summary) || []));
         diffs.push(...(compareField('Body', originalData.body, formDataSnapshot.body) || []));         
     
        if (originalData.doc_talk_mentor_image_upload !== formDataSnapshot.doc_talk_mentor_image_upload) {
          diffs.push(
            <tr className="diff-section-title" key="image-title">
              <td colSpan="4">Changes to <em>Doc Talk Speaker Image</em></td>
            </tr>,
            // <tr key="image-diff">
            //   <td>-</td>
            //   <td>
            //     {originalData.doc_talk_mentor_image_upload && getFileName(originalData.doc_talk_mentor_image_upload)}
            //   </td>
            //   <td>+</td>
            //   <td style={{color:"red",fontWeight:"bold"}}>
            //     {formDataSnapshot.doc_talk_mentor_image_upload && getFileName(formDataSnapshot.doc_talk_mentor_image_upload)}
            //   </td>
            // </tr>
          );
        }
        diffs.push(...(compareField('Zoom Video Recording Link', originalData.videoLink, formDataSnapshot.videoLink) || []));
        diffs.push(...(compareField('Zoom Audio Recording Link', originalData.audioLink, formDataSnapshot.audioLink) || []));
        diffs.push(...(compareField('Doc Talk Chat Time', originalData.field_doc_talk_chat_time, formDataSnapshot.field_doc_talk_chat_time) || []));


       diffs.push(...(compareField('Zoom Chat Link', originalData.field_zoom_chat_link, formDataSnapshot.field_zoom_chat_link) || []));
       diffs.push(...(compareField('Passcode', originalData.field_passcode, formDataSnapshot.field_passcode) || []));   
       diffs.push(...(compareField('Form Frontend Title', originalData.field_form_frontend_title, formDataSnapshot.field_form_frontend_title) || [])); 
     
     

        return diffs.length > 0 ? diffs : (
          <tr className="no-changes">
            <td className="diff-section-title" colSpan="4">No visible changes</td>
          </tr>
        );
      })()
    )}
  </tbody>
</table>
</div>
)}    
                        
{PreviewFields && (
  <>
    <div
      className="messages status"
      style={{
        background: `#f0f8eb url("/images/message-ok.png") no-repeat`,
        backgroundPosition: '10px 10px',
      }}
    >
      The trimmed version of your post shows what your post looks like when promoted
      to the main page or when exported for syndication.
      <span>
        You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
        fine-tune where your post gets split.
      </span>
    </div>

    <div className="preview-container">
      {/* Trimmed version */}
      <div className="preview-trimmed">
        <h4 className="preview-heading">
          <span className="preview-square"></span> Preview trimmed version
        </h4>

        <div className="email-teaser">
          <h2 className="email-title">
            <a href="/full-email-page">{previewData?.title}</a>
          </h2>

          {/* <div className="email-teaser-block1">
            <div className="email-teaser-block2"> */}
              {(previewData.summary?.trim() || previewData.body?.includes('<!--break-->') || previewData.trimmed) && (
  <div
    className="preview-body-content"
    dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
  />
              )}
            {/* </div>
          </div> */}

          <div className="read-more-link">
            <a href="#">Read more</a>
          </div>
        </div>
      </div>

      {/* Full version */}
      <div className="preview-full">
        <h4 className="preview-heading">
          <span className="preview-square"></span> Preview full version
        </h4>

        <div className="email-teaser">
          <h2 className="email-title">
            {/* <strong>Body:</strong> */}
          </h2>

          {/* <div className="email-teaser-block1"> */}
            {/* <div className="email-teaser-block2"> */}
              <div
                dangerouslySetInnerHTML={{
                  __html: previewData.body || '',
                }}
              />
              <div className="email-meta">
                 {previewData.field_file_upload && (
  <p><strong>File to Upload:</strong> {previewData.doc_talk_mentor_image_upload}</p>)}
{previewData.doc_talk_mentor_image_upload && (
  <div>
    <strong>Doc Talk Speaker Image :</strong><br />
    <img 
      src={getImageSrc(previewData.doc_talk_mentor_image_upload)} 
      alt="Preview" 
      style={{ height: "auto", marginTop: "5px" }} 
    />
  </div>
)}


  {previewData.videoLink && (
    <p><strong>Video Link:</strong> <a href={previewData.videoLink} target="_blank" rel="noopener noreferrer">{previewData.videoLink}</a></p>
  )}

  {previewData.audioLink && (
    <p><strong>Audio Link:</strong> <a href={previewData.audioLink} target="_blank" rel="noopener noreferrer">{previewData.audioLink}</a></p>
  )}

  {previewData.field_doc_talk_chat_time && (
    <p><strong>Chat Time:</strong> {previewData.field_doc_talk_chat_time}</p>
  )}

    {previewData.field_zoom_chat_link && (
    <p><strong>Zoom Chat Link:</strong> <a href={previewData.field_zoom_chat_link} target="_blank" rel="noopener noreferrer">{previewData.field_zoom_chat_link}</a></p>
  )}

  {previewData.field_passcode && (
    <p><strong>Passcode:</strong> {previewData.field_passcode}</p>
  )}

  {previewData.field_form_frontend_title && (
      <div
                dangerouslySetInnerHTML={{
                  __html: previewData.field_form_frontend_title || '',
                }}
              />
  )}									  
</div>

            {/* </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  </>
)}

                      
                <div className="edit-doctalk-container">
                             {Object.values(errors).some(msg => !!msg) && (
                                  <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                      background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                  >
                                    <ul>
                                      {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                          <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                  </div>
                                )}
                    <form onSubmit={handleSubmit}>
                        <div>
                            <div className="form-item">
                                <label htmlFor="create-title">
                                    Title
                                    <span className="form-required" title="This field is required.*">*</span>
                                </label>
                                <input 
                                    className="create-title-field" 
                                    type="text" 
                                    id="create-title" 
                                    name="title" 
                                    maxLength={100}
                                    onChange={handleChange} 
                                    style={inputStyle.title}
                                   value={formData.title} 
                                />
                                    {/* {errors.title && (
                                    <div className="form-error">{errors.title}</div>
                                )} */}
                            </div>
                          
                            <div className="">
                                <div>
                                    {showSummary && (
                                        <div className="form-item">
                                            <label htmlFor="create_summary">
                                                Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                            </label>
                                            <>
                                                <>
                                                    <Editor 
                                                        containerProps={{ style: { resize: 'vertical' } }} 
                                                        value={formData.summary} 
                                                        // onChange={e => onEditorChange('summary', e.target.value)} 
                                                        onChange={value => onEditorChange('summary', value)}
                                                    />
                                                </>
                                            </>
                                            <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                        </div>
                                    )}
                            
                                    <div className="form-item">
                                        <label htmlFor="create_body">
                                            Body 
                                            {!showSummary && (
                                                <span>
                                                    (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                        Edit Summary
                                                    </a>)
                                                </span>
                                            )}
                                        </label>
                                        <>
                                            {useRichEditor ? (
                                                <> 
                                                    <Editor 
                                                        containerProps={{ style: { resize: 'vertical' } }} 
                                                        value={formData.body} 
                                                        // onChange={e => onEditorChange('body', e.target.value)}
                                                        // onChange={value => onEditorChange('body', value)}
                                                         onChange={handleEditorChange}

                                                    />  
                                                    <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(false); }}>
                                                        Switch to plain text editor
                                                    </a>
                                                </>
                                            ) : (
                                                <>
                                                    <textarea
                                                        id="create_body"
                                                        rows="20"
                                                        value={formData.body} 
                                                        // onChange={e => onEditorChange('body', e.target.value)} 
                                                        onChange={(e) => setFormData((prev) => ({ ...prev, body: e.target.value })) }
                                                    />
                                                    <div 
                                                        className="grippie" 
                                                        style={{ background: `#eee url("/images/grippie.png") no-repeat center 2px` }}
                                                    >
                                                    </div>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(true); }}>
                                                        Switch to rich text editor
                                                    </a>
                                                </>
                                            )}
                                        </>
                                    </div>                                  
             
             
                                </div>
                            </div>

                         <div className="form-item">
                        <label htmlFor="videoLink">Zoom Video Recording Link</label>
                        <input
                        type="text"
                        id="videoLink"
                        name="videoLink"
                        className="form-input"
                        value={formData.videoLink}
                        onChange={handleChange}
                        maxLength={600}
                        />
                    </div>

                    <div className="form-item">
                        <label htmlFor="audioLink">Zoom Audio Recording Link</label>
                        <input
                        type="text"
                        id="audioLink"
                        name="audioLink"
                        className="form-input"
                        value={formData.audioLink}
                        onChange={handleChange}
                        maxLength={600}
                        />
                    </div>
                    <div>
                        <fieldset style={{border:0,marginLeft:0,paddingLeft:0}}>
                            <legend>Doc Talk Chat Time </legend>
                            <input
                              type="text"
                              name="field_doc_talk_chat_time"
                              value={formData.field_doc_talk_chat_time}
                              onChange={handleChange}
                            />
                            <p style={{marginTop:0}}>Format: {formData.field_doc_talk_chat_time}</p>
                          </fieldset>
                    </div>
                        <div className="form-item">
                        <label htmlFor="field_zoom_chat_link">Zoom Chat Link</label>
                        <input
                        type="text"
                        id="field_zoom_chat_link"
                        name="field_zoom_chat_link"
                        className="form-input"
                        value={formData.field_zoom_chat_link}
                        onChange={handleChange}
                        maxLength={600}
                        />
                    </div>
                     <div className="form-item">
                        <label htmlFor="field_passcode">Passcode</label>
                        <input
                        type="text"
                        id="field_passcode"
                        name="field_passcode"
                        className="form-input"
                        value={formData.field_passcode}
                        onChange={handleChange}
                        maxLength={255}
                        />
                    </div>
                     {/* <div className="edit-profile-row">
                                        <label>Form Frontend Title</label>
                                        <textarea
                                            name="field_form_frontend_title"
                                            value={formData.field_form_frontend_title}
                                            onChange={handleChange}
                                        />
                                        <div className="grippie" style={{
                                            background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                        }}></div>
                                        
                                    </div> */}
                                        {/* <div className="form-item">
                                            <label htmlFor="field_form_frontend_title">
                                                Form Frontend Title
                                            </label>
        
                                            {useFrontendTitleEditor ? (
                                                <>
                                                    <Editor
                                                        containerProps={{ style: { resize: 'vertical' } }}
                                                        value={formData.field_form_frontend_title}
                                                        onChange={(e) =>
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                field_form_frontend_title: e.target.value,
                                                            }))
                                                        }
                                                    />
        
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setUseFrontendTitleEditor(false);
                                                        }}
                                                    >
                                                        Switch to plain text editor
                                                    </a>
                                                </>
                                            ) : (
                                                <>
                                                    <textarea
                                                        name="field_form_frontend_title"
                                                        id="field_form_frontend_title"
                                                        rows="8"
                                                        value={formData.field_form_frontend_title}
                                                        onChange={(e) =>
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                field_form_frontend_title: e.target.value,
                                                            }))
                                                        }
                                                    />
        
                                                    <div
                                                        className="grippie"
                                                        style={{
                                                            background: `#eee url("/images/grippie.png") no-repeat center 2px`,
                                                        }}
                                                    ></div>
        
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setUseFrontendTitleEditor(true);
                                                        }}
                                                    >
                                                        Switch to rich text editor
                                                    </a>
                                                </>
                                            )}
                                        </div> */}


                                            <div>
                                              <div style={{background: "#091C59", padding: "7px 18px", width: "100%"}}>
                                                <a
                                                    href="#"
                                                    className="add-size-link"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        addSizeAttribute();
                                                    }}
                                                >
                                                    + Add Speaker
                                                </a>
                                                </div>
                                                {imageUploadError && (
                                                  <div style={{
                                                    color: '#d9534f',
                                                    border: '1px solid #d9534f',
                                                    backgroundColor: '#fef5f1',
                                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`,
                                                    padding: '10px 10px 10px 40px',
                                                    marginBottom: '10px',
                                                    width: '80%',
                                                    borderRadius: '5px'
                                                  }} dangerouslySetInnerHTML={{ __html: imageUploadError }} />
                                                )}
                                                <table>
                
                                                    <tbody>
                                                        {/* {formData.sizes.map((size, index) => ( */}
                                                        {Array.isArray(formData.mentors) && formData.mentors.map((mentor, index) => {

                                                          const image = selectedImage[index];

                                                          const imageUrl = getFullFileUrl(
                                                            mentor.field_doc_talk_mentor_image
                                                          );

                                                          const imageValue =
                                                            image?.file || mentor.field_doc_talk_mentor_image;

                                                          const fileName =
                                                            imageValue &&
                                                            typeof imageValue === "object" &&
                                                            imageValue.name
                                                              ? imageValue.name
                                                              : typeof imageValue === "string"
                                                              ? imageValue.split("/").pop()
                                                              : "";
                                                          return (
                                                            <tr key={index}>
                                                                <td className="mentor-name-class">
                                                                    Speaker Name:
                                                                    <input
                                                                        type="text"
                                                                        value={mentor.mentor_name ?? ""}
                                                                        onChange={(e) =>
                                                                            handleSizeChange(index, "mentor_name", e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td className="mentor-role-class">
                                                                    Speaker Role:
                                                                    <input
                                                                        type="text"
                                                                        value={mentor.mentor_role ?? ""}
                                                                        onChange={(e) =>
                                                                            handleSizeChange(index, "mentor_role", e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td className="mentor-sort-class">
                                                                    Speaker Sort By:
                                                                    <select
                                                                        value={mentor.mentor_sortby ?? "0"}
                                                                        onChange={(e) =>
                                                                            handleSizeChange(index, "mentor_sortby", e.target.value)
                                                                        }
                                                                    >
                                                                      {Array.from({ length: 11 }, (_, i) => (
                                                                        <option key={i} value={i}>
                                                                          {i}
                                                                        </option>
                                                                      ))}
                                                                    </select>
                                                                </td>

<td className="mentor-image-class">
                        <div className="">

                        Doc Talk Speaker Image:

                        {image ? (
                          // Image has been uploaded and previewed
                          <div className="edit-agent-image-container">
                            <img alt="Uploaded" src={image.preview} width="90" height="100" />
                            <div className="image-info">
                              <a
                                href={image.preview}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="image-name-link"
                              >
                                 <img
                                  src={getFileIcon(fileName)}
                                  alt="File Icon"
                                  style={{ width: '16px', height: '16px', marginRight: '5px', verticalAlign: 'middle' }}
                                />
                                {image.file.name}
                              </a>
                              <span className="image-size">
                                ({formatFileSize(image.file.size)})
                              </span>
                            </div>
                            <input
                              type="button"
                              value="Remove"
                              className="form-submit"
                              onClick={() => removeImage(index)}
                            />
                          </div>
                        ) :  mentor.field_doc_talk_mentor_image ? (
                          // Previously saved image (from backend)
                          <div className="edit-scout-report-image-container">
                            <img
                              alt="Uploaded"
                             // src={formData.field_doc_talk_mentor_image}
                            // src={getFullFileUrl(formData.field_doc_talk_mentor_image)}
                            src={imageUrl}
                              width="90"
                              height="100"
                            />
                            <div className="image-info">
                              <a
                              //  href={formData.field_doc_talk_mentor_image}
                               // href={getFullFileUrl(formData.field_doc_talk_mentor_image)}
                               href={imageUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="image-name-link"
                              >
                                 <img
                                  src={getFileIcon(fileName)}
                                  alt="File Icon"
                                  style={{ width: '16px', height: '16px', marginRight: '5px', verticalAlign: 'middle' }}
                                />
                                {fileName}
                              </a>
                                {savedImageInfo?.size && (
                          <span className="image-size">
                            ({formatFileSize(savedImageInfo.size)})
                          </span>
                        )}
                            </div>
                            <input
                              type="button"
                              value="Remove"
                              className="form-submit"
                              onClick={() => removeImage(index)}
                            />
                          </div>
                        ) : (
                          // No image yet
                          <div>
                            <input
                              type="file"
                              id="edit-agent-photo-upload"
                              name="doc_talk_mentor_image_upload"
                              accept="image/*"
                              onChange={(e) => handleTempImageChange(e, index)}
                            />
                            <input
                              type="button"
                              value="Upload"
                              className="form-submit"
                              onClick={handleUploadClick}
                              disabled={!tempImageFile}
                            />
                          </div>
                        )}
                      </div>

                        <div style={{clear:"both"}}></div>
</td>

                                                                <td className="mentor-action-class">
                                                                    <a
                                                                        href="#"
                                                                        className="remove-size-link"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            removeSizeAttribute(index);
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src="/basic/web/images/delete_icon.png"
                                                                            alt="Remove"
                                                                            className="remove-icon"
                                                                            style={{maxWidth: "20px", maxHeight: "20px", verticalAlign: "middle"}}
                                                                        />
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        );})}
                                                    </tbody>
                                                </table>

                                              {!(selectedImage || formData.doc_talk_mentor_image_upload) && (
                                                <div className="description" style={{ lineHeight: "1.2" }}>
                                                  Files must be less than <strong>128 MB</strong>.<br />
                                                  Allowed file types: <strong>png gif jpg jpeg</strong>.<br />
                                                  Images must be at least <strong>400x400</strong> pixels.
                                                </div>
                                              )}
                                                
                                            </div>

                                <div className="form-item">
                                    <label htmlFor="relate_sports">Relate Sports</label>
                                    <select
                                    id="relate_sports"
                                    name="relate_sports"
                                    className="form-input"
                                    value={formData.relate_sports}
                                    onChange={handleChange}
                                    >
                                      <option value="">-None-</option>
                                    
                                      <option value="Baseball">Baseball</option>
                                      <option value="Basketball">Basketball</option>
                                      <option value="Cricket">Cricket</option>
                                      <option value="Esports">Esports</option>
                                      <option value="Football">Football</option>
                                      <option value="Hockey">Hockey</option>
                                      <option value="Motorsports">Motorsports</option>
                                      <option value="Rugby">Rugby</option>
                                      <option value="Soccer">Soccer</option>
                                    </select>
                                </div>


                                    <div className="doc-talk-sortflag-select">
                                      <label>Relate Sortflag</label>
                                        <Select
                                          id="relate_sortflag"
                                          name="relate_sortflag"
                                          searchable
                                          clearable
                                          clearOnBlur
                                          clearOnSelect
                                          backspaceDelete
                                          options={sortflagList}

                                          values={
                                            sortflagList.filter(
                                              item => Number(item.value) === Number(formData.relate_sortflag)
                                            )
                                          }

                                          onChange={(val) => {
                                            setFormData(prev => ({
                                              ...prev,
                                              relate_sortflag: val?.[0]?.value ?? ''
                                            }));
                                          }}
                                        />
                                    </div>

                            <div className="form-actions form-wrapper" id="create-actions">
                                <input type="submit" id="create-submit" name="" value="Save" className="form-submit" />&nbsp;&nbsp;
                               <input 
                                          type="button" 
                                          id="edit-preview"  
                                          value="Preview" 
                                          className="form-submit" 
                                          onClick={()=> {
                                          handlePreviewClick();
                                          }}
                                        />  &nbsp;&nbsp;
            <input
                                          type="button"
                                          id="edit-task-preview-changes"
                                          value="View changes"
                                          className="form-submit"
                                          onClick={handleViewChangesClick}
                                        />&nbsp;&nbsp;
          <input type="button" className="form-submit" value="Delete" 
          onClick={handleDelete}
          />                                   

                                       
                            </div>
                        </div>
                    </form>
                                          
                </div>
               </div> 
            </div>
            <div className="right">
                <SalespersonSidebar/>
            </div>
        </div>
            )}
            </>
    );
};
export default EditDocTalk;